// extracted by mini-css-extract-plugin
module.exports = {"box":"AboutUs_box__9FXLO","gridItem":"AboutUs_gridItem__3Zbbz","gridItemImg":"AboutUs_gridItemImg__3IywV"};